import { render, staticRenderFns } from "./risks.vue?vue&type=template&id=b2827f08&"
import script from "./risks.vue?vue&type=script&lang=js&"
export * from "./risks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports